import script from "./blog-post-article.vue?vue&type=script&setup=true&lang=js"
export * from "./blog-post-article.vue?vue&type=script&setup=true&lang=js"

import "./blog-post-article.vue?vue&type=style&index=0&id=7e2d7e8e&lang=scss&scoped=true"

import exportComponent from "/opt/www/novasector.net/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e2d7e8e"]])

export default __exports__